import { api } from '@/core/api/';
const URL = 'api/location';

export const getMunicipalities = (params = {}) =>
  api.get(`${URL}/municipalities`, { params });
export const getRegions = (params = {}) =>
  api.get(`${URL}/regions`, { params });
export const getDistricts = (params = {}) =>
  api.get(`${URL}/districts`, { params });
export const getSchools = (params = {}) =>
  api.get(`${URL}/schools`, { params });
export const getCenters = (params = {}) =>
  api.get(`${URL}/centers`, { params });
export const getCenterAddress = (centerId) =>
  api.get(`${URL}/centeraddress`, { params: { centerId } });
export const getLocationSchoolAddress = (locationSchoolId, academicYearId) =>
  api.get(`${URL}/locationSchoolAddress`, {
    params: { locationSchoolId, academicYearId },
  });
export const getAddressTypes = () => api.get(`${URL}/addresstypes`);
export const addLocationAddress = (payload) =>
  api.post(`${URL}/addaddress/`, payload);
export const editLocationAddress = (id, payload) =>
  api.put(`${URL}/editaddress/${id}`, payload);
export const deleteLocationAddress = (id) =>
  api.delete(`${URL}/deleteaddress/${id}`);
export const getMunicipalitiesByProvider = (
  academicYearId,
  companyId,
  locationTypeId
) => {
  let uri = `${URL}/municipalitiesbyprovider/${academicYearId}/${companyId}`;

  if (locationTypeId) uri += `/${locationTypeId}`;

  return api.get(uri);
};
export const getLocatioSchoolType = (locationSchoolId) =>
  api.get(`${URL}/locationschooltype/${locationSchoolId}`);
